import React, { useState } from 'react';
import Navigator from '../Navigator';
import { useLocation, useNavigate } from 'react-router-dom';
const LayoutComponent = ({ children }) => {
  const location = useLocation();
  const [activeRoute, setActiveRoute] = useState(location.pathname?.split('/')[1]);

  const navigate = useNavigate();
  const handleClick = (route) => {
    navigate(route);
    setActiveRoute(route.split('/')[1]);
  };
  return (
    <>
      {children}
      <Navigator active={activeRoute} handleClick={handleClick} />
    </>
  );
};

export default LayoutComponent;
